import { useCallback, useEffect, useRef, useState } from 'react';

const EXIT_DURATION = 240;

export function useAnimatedClose(onClose: () => void) {
  const [closing, setClosing] = useState(false);
  const timer = useRef<number | null>(null);

  useEffect(() => () => {
    if (timer.current !== null) window.clearTimeout(timer.current);
  }, []);

  const requestClose = useCallback((afterClose: () => void = onClose) => {
    if (closing) return;
    setClosing(true);
    timer.current = window.setTimeout(() => {
      setClosing(false);
      afterClose();
    }, EXIT_DURATION);
  }, [closing, onClose]);

  return { closing, requestClose };
}
